export enum ArticleTypes {
  FETCH_ARTICLES = "FETCH_ARTICLES",
  SET_ARTICLE = "SET_ARTICLE",
  FETCH_COMMENTS = "FETCH_COMMENTS",
}
